<template>

    <div class="layout__container text__align-center">
        <div class="layout__padding-20-0">
            <h3 class="">We haven't been able to match your file<br> to one of our products.</h3>
        </div>

        <div class="">
            <p>We're unable to support this combination of size and pages:</p>
        <div class="layout__padding-20-0">
            <!--<p>{{pdf}}</p>-->
            <div class="">
                {{printJob.printJobSpec.pageCount}} pages | {{printJob.printJobSpec.actualPageWidth}}mm x
                {{printJob.printJobSpec.actualPageHeight}}mm | {{printJob.printJobSpec.pageOrientation}}
            </div>
        </div>
        </div>

        <div class="layout__padding-20-0">
            <el-button
                    class="button-red button__base layout__position-center layout__width-200px"
                    v-on:click="upload()">
                Upload Another File
            </el-button>

        </div>

        <div class="layout__padding-20-0">
            <p>Please contact our team who will be happy to review your template<br> and enable you to print with
                us.</p>
            <div class="layout__padding-20-0">
                <p>Ravensworth Client Services:</p>
                <p class="text__colour-teal">01865 712211</p>
                <p class="text__colour-teal">orders@printconcern.co.uk</p>
            </div>
        </div>
    </div>

</template>

<script>

    import Router from '../../../router';

    export default {
        name: "noproducts",
        components: {},
        props: {
            printJob: {}
        },
        data() {
            return {
                pdf: ''
            }
        },
        created() {
            this.pdf = window.sessionStorage.getItem('_filename')
        },
        methods: {
            upload() {
                Router.push({
                    name: '/instant-print',
                    params: {
                        printJob: this.printJob,
                        searchParams: this.searchParams
                    }
                });
            }
        }
    };
</script>
